class WildWolfDisplay extends PIXI.Container {
  constructor() {
    super();

    gameController.reelData = [];

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );
    messageBus.subscribe("game:wolfRun", this.onWolfRun.bind(this));
    this.wildWolfArr = [];
    this.tweensToKill = [];
    this.active = false;
    this.chosenSWCopies = [];
    this.randomSelector = [0, 1, 2, 3, 4, 5];
    this.visible = false;
    this.wolfRunCount = 0;
    this.fogCount = 0;
    Reflex.registerEventHandler(
      "layoutChange",
      gameController.onOrientationChange
    );
  }

  initialise() {
    this.darkBG = resourceManager.get(
      "slotContainer:wildWolfDisplay:darkBackground"
    );
    this.darkBG.beginFill(0x000000, 0.8);
    this.darkBG.drawRect(0, 0, 1047, 537);
    this.darkBG.endFill();

    this.darkBG.visible = false;

    this.shaker = resourceManager.get("slotShaker");

    for (let reel = 0; reel < gameData.numReels; reel++) {
      const orginWSx = gameController.reelData[reel].position.x + 8;
      const orginWSy = gameController.reelData[reel].position.y;
      let wildWolf = resourceManager.createObject(
        "movie",
        `wildWolf${reel}`,
        this,
        {
          definition: "Symbol_Wild_1x4WolfRun",
          loop: false,
          x: orginWSx,
          y: orginWSy,
          anchor: 0.5,
        }
      );

      wildWolf.visible = false;
      this.wildWolfArr.push({
        wildWolf,
      });
    }

    this.fogMovie = resourceManager.createObject("movie", `fogMovie`, this, {
      definition: "fogMovie",
      loop: false,
      x: 0,
      y: 149,
      anchor: 0.5,
    });

    this.fogMovie.gotoAndStop(0);
    this.fogMovie.visible = false;

    this.wolfWildID =
      resourceManager.getConfiguration().symbols.Symbol_Wild_1x4.ID;
  }

  onWolfRun = function (task) {
    gameController.reelStopping = [false, false, false, false, false, false];
    gameController.overSizedInProcess = true;
    for (let reel = 0; reel < gameData.numReels; reel++) {
      gameData.reels[
        reel
      ].onSpin(); /*a bit hacky but i'm transferring data over to the spin coins*/
      gameData.reels[reel].redraw();
    }
    const self = this;
    this.visible = true;

    gameController.isInWolfRun = true;
    gameController.stopSymbolFrameDisplay();

    const messageBox = (resourceManager.get(
      "messageBox:messageBox"
    ).visible = false);

    gameController.clearMoonValues();
    gameController.clearCoinValues();

    this.wildWolfRunTask = task;
    this.wildWolfRunTask.join();

    this.chosenSWCopies = [];
    this.wolfRunData = task.data.wolfRunReels;

    //keeping for ma bit
    // gameController.valueOverlays.clearAllSpinMoonValues();
    // gameController.valueOverlays.clearAllSpinCoinValues();
    gameController.shaker.doShake(1500, function () {
      gsap.fromTo(
        self.darkBG,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 1.5,
          onStart: () => {
            gameController.reelStopping = [
              false,
              false,
              false,
              false,
              false,
              false,
            ];
            self.darkBG.visible = true;
            soundManager.play("dim");
            gameController.messageBox.showLogo(true);
          },

          onComplete: () => {
            self.active = true;
            //keeping for a bit
            // gameController.reelStopping = [
            //   false,
            //   false,
            //   false,
            //   false,
            //   false,
            //   false,
            // ];
            self.startFog();
          },
        }
      );
    });

    //soundManager.play("superWildExpand");
  };

  startFog() {
    const self = this;

    if (this.wolfRunCount < this.wolfRunData.length) {
      let chosenReel =
        this.randomSelector[
          Math.floor(Math.random() * this.randomSelector.length)
        ];

      this.randomSelector.splice(this.randomSelector.indexOf(chosenReel), 1);
      //move fog to reel
      this.fogMovie.x = gameController.reelData[chosenReel].position.x + 3;
      this.fogMovie.visible = true;
      soundManager.play("wolfRunSmokeOrPowerPackWind");

      let isWolf = this.checkWolf(chosenReel);
      if (isWolf) {
        this.wolfRunCount++;
        self.fogMovie.onComplete = function () {
          self.fogMovie.visible = false;
          self.fadeInWolfWild(chosenReel);
        };
        this.fogMovie.gotoAndPlay(0);
      } else {
        if (this.fogCount < 2) {
          this.fogCount++;
          this.fogMovie.onComplete = function () {
            self.startFog();
          };
          this.fogMovie.gotoAndPlay(0);
        } else {
          this.startFog();
        }
      }
    } else {
      this.animationComplete();
    }
  }

  checkWolf(reel) {
    let isMatch = false;
    for (let i = 0; i < this.wolfRunData.length; i++) {
      if (this.wolfRunData[i].wolfRunReel === reel) {
        isMatch = true;
      }
    }
    return isMatch;
  }

  onOrientationChange() {
    //Backgrounds
    switch (layoutController.getCurrentLayout()) {
      case "landscape_default":
      case "landscape_mobile": {
        break;
      }
      case "portrait_default":
      case "portrait_mobile":
      default: {
        break;
      }
    }

    if (this.active) {
      this.fogMovie.gotoAndStop(0);
      this.fogMovie.visible = false;
      this.darkBG = resourceManager.get(
        "slotContainer:wildWolfDisplay:darkBackground"
      ).visible = true;
    }
  }

  fadeInWolfWild(reel) {
    const self = this;
    this.wildWolfArr[reel].wildWolf.onComplete = function () {
      for (let i = 0; i < gameData.numRows + 2; i++) {
        gameData.reels[reel].showSymbol(i, false);
      }
      self.startFog();
    };
    this.wildWolfArr[reel].wildWolf.visible = true;
    this.wildWolfArr[reel].wildWolf.gotoAndPlay(0);
    soundManager.play("winWolf");
  }

  animationComplete = function () {
    gsap.fromTo(
      this.darkBG,
      {
        alpha: 1,
      },
      {
        alpha: 0,
        duration: 0.5,
        onStart: () => {},
        onComplete: () => {
          this.active = false;
          this.wildWolfRunTask.leave();
        },
      }
    );
  };

  resetWildWolfRun() {
    gameController.isInWolfRun = false;
    resourceManager.get("messageBox:messageBox").visible = true;
    for (let i = 0; i < this.wildWolfArr.length; i++) {
      this.wildWolfArr[i].wildWolf.visible = false;
    }
    for (let i = 0; i < this.wolfRunData.length; i++) {
      for (let j = 0; j < gameData.numRows + 2; j++) {
        gameData.reels[this.wolfRunData[i].wolfRunReel].showSymbol(j, true);
      }
    }
    this.animationEnded = false;
    this.randomSelector = [0, 1, 2, 3, 4, 5];
    this.wolfRunCount = 0;
    this.fogCount = 0;
  }

  onGameConfigEvent() {
    this.initialise();
  }
}

var wildWolfDisplayCreator = function (json) {
  return new WildWolfDisplay();
};

var wildWolfDisplayInitialiser = function (json, buggy) {};

var wildWolfDisplayFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "wildWolfDisplay",
  wildWolfDisplayCreator,
  wildWolfDisplayInitialiser,
  wildWolfDisplayFilesRequired
);
